// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"949e2534","159":"f93259d3","602":"36b7a7d3","824":"8582d6ba"}[chunkId] + ".chunk.js";
};